import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer'; // IntersectionObserver polyfill
// import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';
gsap.registerPlugin(CSSPlugin);
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './containers/AppContainer';
import 'normalize.css/normalize.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'styles/main.styl';


const container = document.querySelector('#app');
const root = createRoot(container);

function initRender() {
	root.render(<App />);
}

initRender();

if (module.hot) {
	module.hot.accept('containers/AppContainer', () => initRender());
}

// if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
// 	OfflinePluginRuntime.install();
// }

// need browser extension
// if (__DEV__) {
// 	const registerObserver = require('react-perf-devtool');
// 	registerObserver();
// }
